import { mailStore } from 'owa-mail-store';
import { action, select } from 'satcheljs/lib/legacy';
import getItemTailoredXpData from './getItemTailoredXpData';
var CHRONOLOGICAL_NEWEST_ON_BOTTOM_SORT_ORDER_NAME = 'ChronologicalNewestOnBottom';
export default action('getConversationTailoredXpData')(select({
    items: function () { return mailStore.items; },
})(function getConversationTailoredXpData(conversationNodes, conversationSortOrder, state) {
    // Check the first node's items for TxP data.
    var isNewestOnBottom = conversationSortOrder == CHRONOLOGICAL_NEWEST_ON_BOTTOM_SORT_ORDER_NAME;
    var indexOfFirstNode = isNewestOnBottom ? 0 : conversationNodes.length - 1;
    var node = conversationNodes[indexOfFirstNode];
    node.Items.forEach(function (newItem) {
        getItemTailoredXpData(newItem, state);
    });
}));
//# sourceMappingURL=getConversationTailoredXpData.js.map